
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/przejecie-projektu-od-innego-wykonawcy",
      function () {
        return require("private-next-pages/przejecie-projektu-od-innego-wykonawcy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/przejecie-projektu-od-innego-wykonawcy"])
      });
    }
  